import { createContext } from 'react';

const SpauthServiceContext = createContext();

export default SpauthServiceContext;

